import type { TransformerId } from '@finance/contracts';

export type Transformer = (value: unknown, params?: Record<string, unknown>) => unknown;

const transformers = new Map<string, Transformer>();

export function registerTransformer(id: TransformerId, transformer: Transformer): void {
  transformers.set(id as string, transformer);
}

export function getTransformer(id: TransformerId): Transformer | undefined {
  return transformers.get(id as string);
}

export function applyTransformer(
  id: TransformerId,
  value: unknown,
  params?: Record<string, unknown>,
): unknown {
  const transformer = getTransformer(id);
  if (!transformer) {
    throw new Error(`Unknown transformer: ${String(id)}`);
  }
  return transformer(value, params);
}
